import React from 'react';
import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    logo: {
        flexGrow: 0.01
    },
    title: {
        flexGrow: 1,
    },
    icon: {
        marginLeft: theme.spacing(1),
    },
    toolbar: {
        justifyContent: "space-around"
    }
}));

const Header = () => {
    const classes = useStyles();
    return (
        <div className={'header'}>
            <img
                src={"/logo-horiz-white.png"}
                loading="lazy" width="210" alt=""/>

            <div className={'header-right'}>
                <a href="https://t.me/statemesh" target="_blank" className="followus w-inline-block">
                    <div className="text-block">Join our Telegram</div>
                </a>

                <a href="https://x.com/statemeshnet" className="followus w-inline-block">
                    <div className="text-block">Follow us on X</div>
                </a>
            </div>
        </div>
    );
}

export default Header;
